<template>
  <dynamic-form :params="params" formtype="flowform" v-on:toggle-form="toggleForm" v-if="showform"/>
</template>
<script>
import DynamicForm from '@/components/DynamicForm/DynamicForm'
export default {
  components: { DynamicForm },
  data() {
    return {
      params: {
        blueprintid: this.$route.params.blueprint,
        form: 'flowform'
      },
      showform: true
    }
  },
  methods: {
    toggleForm() {
      this.$router.push('/mtflow/base')
    }
  }
}
</script>
